/*
 *
 * File: Footer.jsx
 *
 * Purpose: Multistop booking page footer component.
 *
 * Autor:   Thomas Burgard (Software development)
 * Created: 23.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import React from 'react';

/**
 * Implementation of Multistop page footer component.
 *
 * @param {*} props user data
 * @returns JSX-HTML-DOM
 */
const Footer = (props) => {
  const userData = props.userData;
  const whiteLabel = props.userData.regData.WHITELABEL;

  //*************************************************************/
  //* Returns JSX code for "Footer"                             */
  //*************************************************************/
  if (whiteLabel === "1") {
    return null;
  } else {
    return <div className="footer-area">Copyright © 2022 DrivePartner</div>;
  }    
};

export default Footer;
